/**
 * @generated SignedSource<<a9915cd15b2102b43127498de4c8c6aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionViewToolbar_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useDibsSetApprovalForAll_viewer">;
  readonly " $fragmentType": "NftProfileImportCollectionViewToolbar_viewer";
};
export type NftProfileImportCollectionViewToolbar_viewer$key = {
  readonly " $data"?: NftProfileImportCollectionViewToolbar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionViewToolbar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionViewToolbar_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useDibsSetApprovalForAll_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b7d8a81bb8610724dc9afd8eaa086754";

export default node;
